import { useState, useEffect } from "react";
import I18n from "common/i18n";
import { useScale } from "common/utils";
import { Layout, Overlay } from "features/creator/tutorial/top/stages/Layout";
import { Title } from "../Title";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { scale } = useScale();
  const { back, next, close } = props;
  const [panelRect, setPanelRect] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    setTimeout(() => {
      const panel = document.getElementById("user-project-panel-drawer");
      const rect = panel.getBoundingClientRect();
      setPanelRect({
        x: rect.x - 50 * scale,
        y: rect.y - 70 * scale,
        width: 450 * scale,
        height: 450 * scale,
      });
    }, 300);
  }, [scale]);

  return (
    <>
      <Overlay area={panelRect}>
        <></>
      </Overlay>

      <Layout transparent back={back} next={next} close={close}>
        <Title activeStep={1} />

        <div className="flex-col-el items-start justify-center w-[312px]">
          <p className="text-body text-textcolor-black text-[22px] whitespace-pre text-center">
            {I18n.locale === "ja" ? "アプリを つくったら" : "アプリを作ったら"}
          </p>
          <div className="flex-row-el gap-2">
            <div className="flex-row-el flex-center px-3 bg-orange-100 rounded-xl">
              <p className="text-body text-[20px] leading-8 text-white">
                {I18n.t("MSG_CREATOR_APP_MY_APPS")}
              </p>
            </div>

            <p className="text-body text-textcolor-black text-[22px] whitespace-pre text-center">
              {I18n.locale === "ja" ? "に ひょうじ" : "に表示"}
            </p>
          </div>
          <p className="text-body text-textcolor-black text-[22px] whitespace-pre text-center">
            されます。
          </p>
        </div>
      </Layout>
    </>
  );
};

export default Step;
